import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import CtaBanner from "../components/CtaBanner";
import { PRICING } from "../data/services";

const CATEGORIES = [
  { key: "nails", label: "Stylizacja paznokci", keyword: "stylizacja paznokci Katowice", data: PRICING.nails },
  { key: "manicure", label: "Manicure", keyword: "manicure Katowice", data: PRICING.manicure },
  { key: "pedicure", label: "Pedicure frezarkowy", keyword: "pedicure Katowice", data: PRICING.pedicure },
  { key: "depilation", label: "Depilacja", keyword: "depilacja Katowice", data: PRICING.depilation },
  { key: "eyes", label: "Stylizacja oka", keyword: "stylizacja brwi rzęs Katowice", data: PRICING.eyes },
  { key: "podology", label: "Podologia", keyword: "podolog Katowice", data: PRICING.podology },
  { key: "face", label: "Kosmetyka twarzy", keyword: "kosmetyka twarzy Katowice", data: PRICING.face },
];

export default function PricingPage() {
  return (
    <>
      <Seo
        title="Cennik BEAUTIX Katowice — Paznokcie, Podologia, Kosmetyka Twarzy"
        description="Aktualny cennik usług BEAUTIX Katowice: manicure hybrydowy od 130 zł, pedicure leczniczy od 180 zł, mezoterapia mikroigłowa od 350 zł. Zobacz pełen cennik."
        keywords="cennik manicure Katowice, cennik podolog Katowice, cennik kosmetyka twarzy Katowice, BEAUTIX cennik"
        path="/cennik"
      />

      <section className="max-w-7xl mx-auto px-6 md:px-10 pt-8 pb-4">
        <Breadcrumbs items={[{ label: "Cennik" }]} />
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 py-12 md:py-20">
        <p className="eyebrow mb-4">Cennik</p>
        <h1 className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight max-w-3xl">
          Przejrzyste ceny.
          <br />
          Bez ukrytych kosztów.
        </h1>
        <p className="mt-8 max-w-2xl text-lg text-[var(--beautix-muted)] leading-relaxed font-light">
          Ceny zabiegów w BEAUTIX ustalamy tak, żeby były uczciwe wobec Twojej
          skóry i płytki paznokcia. Wartości poglądowe — dokładna cena zależy
          od stanu wyjściowego i długości zabiegu. Chętnie doprecyzujemy przy
          rezerwacji.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-24 space-y-20">
        {CATEGORIES.map((cat) => (
          <div key={cat.key} data-testid={`pricing-${cat.key}`}>
            <div className="flex flex-col md:flex-row md:items-baseline md:justify-between mb-8 gap-2">
              <h2 className="font-serif-display text-3xl md:text-4xl">
                {cat.label}
              </h2>
              <span className="text-xs tracking-[0.28em] uppercase text-[var(--beautix-muted)]">
                {cat.keyword}
              </span>
            </div>
            <div className="divide-y divide-[var(--beautix-line)] border-y border-[var(--beautix-line)]">
              {cat.data.map((item, idx) =>
                item.group ? (
                  <div
                    key={`g-${idx}-${item.group}`}
                    className="pt-8 pb-3 first:pt-4"
                  >
                    <p className="eyebrow text-[var(--beautix-pink)]">
                      {item.group}
                    </p>
                  </div>
                ) : (
                  <div
                    key={`${idx}-${item.name}`}
                    className="flex items-baseline justify-between gap-4 py-5"
                  >
                    <span className="text-base md:text-lg font-light text-[var(--beautix-ink)]">
                      {item.name}
                    </span>
                    <span className="text-base md:text-lg font-serif-display text-[var(--beautix-pink)] whitespace-nowrap">
                      {item.price}
                    </span>
                  </div>
                ),
              )}
            </div>
          </div>
        ))}
      </section>

      <CtaBanner
        title="Nie widzisz swojego zabiegu w cenniku?"
        subtitle="Zadzwoń — dobierzemy najlepszy zabieg do Twoich potrzeb i podamy dokładną cenę."
      />
    </>
  );
}
